//INITIAL LABELS DATA
export default {
    global: {
        systemTitle: {titulo: "RECUPERAÇ\u00C3O DE SENHA / 1\u00BA Acesso"},

        titleModal401Error: {titulo: "Tempo de sessão expirado"},
        textModal401Error: {titulo: "O tempo limite para a conclusão do processo de recuperação de senha se esgotou. Para sua segurança, reinicie o processo."},

        titleModal403Error: {titulo: "Acesso bloqueado"},
        textModal403Error: {titulo: "Prezado(a) Associado(a), a recuperação automatizada de sua senha de acesso foi bloqueada. Por favor, entre em contato com a Cooperforte. "},

        textModal404InvalidInformation: {titulo: "Infelizmente ocorreu um erro que não nos permitiu prosseguir com o processo de recuperação de senha. Por favor, entre em contato com a COOPERFORTE. "},

        required: {titulo: "Campo obrigatório"},

        titleModal409Error: {titulo: "Senha inválida"},

        nextBtn: {titulo: "Continuar"},
        nextBtnDesc: {titulo: "Avança para o próximo passo da recuperação da senha"},

        closeBtn: {titulo: "Fechar"},
        closeBtnDesc: {titulo: "Fecha essa janela e retorna ao passo anterior"},

        continueProcessBtn: {titulo: "Continuar"},
        continueProcessBtnDesc: {titulo: "Fecha essa janela e avança para o próximo passo da recuperação da senha"},
        validarCodigoBtn: {titulo: "Validar o código"},

        labelSupportCentral: {titulo: "Central de Atendimento:"},
        centralTelephoneNumber: {titulo: "4007-2762 (Capital e regiões metropolitanas)"},
        centralTelephoneNumber2: {titulo: "0800 701 3766 (Demais localidades)"},
    },

    login: {
        welcomeText1: {titulo: "Olá, esqueceu sua senha?"},
        welcomeText2: {titulo: "Não se preocupe, vamos recuperá-la!"},
        welcomeText3: {titulo: "Para cadastrar ou recuperar sua senha, preencha seu CPF e Data de Nascimento, clique em não sou robô e depois em continuar."},

        cpfField: {titulo: "Informe seu CPF"},
        birthdayField: {titulo: "Informe sua Data de Nascimento"},

        captchaInfo: {titulo: "Responda à pergunta de segurança acima"},
        invalidCpf: {titulo: "CPF Inválido"},
        invalidBirthday: {titulo: "Data de nascimento inválida"},
        titleModalRPStarted: {titulo: "Recuperação de senha / 1º acesso"},
        text1ModalRPStarted: {titulo: "Você solicitou uma nova senha de acesso aos canais digitais da COOPERFORTE. Para confirmar, um código de segurança será enviado ao seu e-mail e por SMS ao seu celular, conforme cadastro junto à cooperativa:"},
        text1ModalRPStartedCelular: {titulo: "Para confirmar a autenticidade deste acesso, será necessária uma segunda validação, onde um código de seguran\u00E7a foi enviado ao seu Celular (SMS) cadastrado na COOPERFORTE."},
        text1ModalRPStartedEmail: {titulo: "Para confirmar a autenticidade deste acesso, um código de seguran\u00E7a foi enviado ao seu E-mail cadastrado na COOPERFORTE."},
        text2ModalRPStarted: {titulo: "Será necessário a confirmação desse código para prosseguir com o processo de recuperação da senha."},

        titleModal403Error: {titulo: "Não foi possível prosseguir com sua solicitação!"},

        titleModal404Error: {titulo: "Dados inválidos"},
        textModal404Error: {titulo: "Os dados informados são inválidos. Verifique-os e tente novamente."},

        titleModal400Error: {titulo: "Processo de recuperação de senha de acesso"},
        textModal400Error: {titulo: "Desculpe, mas não encontramos seus dados de contato. Por favor, entre em contato com a nossa Central de Atendimento."},

        titleModal401Error: {titulo: "Acesso bloqueado"},
        textModal401Error: {titulo: "Prezado(a) Associado(a), a recuperação automatizada de sua senha de acesso foi bloqueada. Por favor, entre em contato com a Cooperforte. "},

        semEmailECelular1: {titulo: "Para recuperação da SENHA DE ACESSO, entre em contato com nossa Central de Atendimento pelos números: "},
        titleModal406Error: {titulo: "Associação em análise"},
        textModal406rror1: {titulo: "Seu pedido de associação foi finalizado e já está sendo analisado!"},
        textModal406rror2: {titulo: "Fique tranquilo, nós vamos te avisar quando a análise for concluída."},
        textModal406rror3: {titulo: "Ative as notificações do APP COOPERFORTE no seu telefone celular para receber nossas comunicações."},
    },

    tokenEmail: {
        welcomeText: {titulo: "Digite abaixo o código de segurança que você recebeu em seu E-mail:"},
        confirmationToken: {titulo: "Código de Segurança"},
        footerText1: {titulo: "Dúvidas? Entre em contato com a nossa Central de Atendimento no"},
        footerText2: {titulo: "4007-2762 (Capital e regiões metropolitanas) ou 0800 701 3766 (Demais localidades)."},
        incompleteCode: {titulo: "Código incompleto"},

        titleModalTokenValid: {titulo: "Código de Segurança"},
        textModalTokenValid: {titulo: "Código de Segurança validado com sucesso."},

        titleModal400Error: {titulo: "Código de Segurança"},
        textModal400Error: {titulo: "Código Incorreto. Verifique-o e tente novamente."},

        validateBtn: {titulo: "Validar"},
        validateBtnDesc: {titulo: "Valida o código de segurança informado"},
    },

    tokenSms: {
        welcomeText: {titulo: "Digite abaixo o código de segurança que você recebeu em seu Celular (SMS):"},
        confirmationToken: {titulo: "Código de Segurança"},
        footerText1: {titulo: "Dúvidas? Entre em contato com a nossa Central de Atendimento no"},
        footerText2: {titulo: "4007-2762 (Capital e regiões metropolitanas) ou 0800 701 3766 (Demais localidades)."},
        incompleteCode: {titulo: "Código incompleto"},
        text1ModalRPStartedSms: {titulo: "Para confirmar a autenticidade deste acesso, um código de seguran\u00E7a foi enviado ao seu Celular SMS) cadastrado na COOPERFORTE."},
        titleModalTokenValid: {titulo: "Código de Segurança"},
        textModalTokenValid: {titulo: "Código de Segurança validado com sucesso."},
        titleModal400Error: {titulo: "Código de Segurança"},
        textModal400Error: {titulo: "Código Incorreto. Verifique-o e tente novamente."},
        generateNewCode: {titulo: "Enviar novo código (SMS ou WhatsAPP)"},
        optionsGenerateNewCode: {titulo: "Escolha como prefere enviar o novo código:"},
        validateBtn: {titulo: "Validar"},
        validateBtnDesc: {titulo: "Valida o código de segurança informado"},
    },
    newTokenWhatsApp: {
        welcomeText: {titulo: "Digite abaixo o código de segurança que você recebeu em seu Celular (WhatsApp):"},
        textModalNewToken: {titulo: "Novo código enviado por WhatsApp"},
        newCodeBtnWhatsApp: {titulo: "Quero receber novo código por WhatsApp"},
    },

    newTokenSms: {
        titleModalNewToken: {titulo: "Solicitação de novo código"},
        newCodeBtnSms: {titulo: "Quero receber novo código por SMS"},
        textModalNewToken: {titulo: "Novo código enviado por SMS"},
        textBtn: {titulo: "Ciente"},
        titleErrorModal: {titulo: "Falha nossa!"},
        textErrorModal: {titulo: "Ocorreu um erro inesperado!"}
    },

    question: {
        footerText1: {titulo: "Dificuldades em responder as perguntas?"},
        footerText2: {titulo: "Favor entrar em contato com nossa Central de Atendimento"},
        welcomeText: {titulo: "Responda a pergunta abaixo"},
        errorNoAnswer: {titulo: "\u00C9 obrigat\u00F3rio responder a pergunta!"},
        sendBtn: {titulo: "Continuar"},
        sendBtnDesc: {titulo: "Responda a questão"}
    },

    password: {
        titleModalSenha: {titulo: "Senha de acesso cadastrada com sucesso!"},
        welcomeText3: {titulo: "Cadastramento de senha de acesso aos canais digitais"},
        newPasswordField: {titulo: "Digite sua senha de acesso de 8 a 20 caracteres"},
        repeatPasswordField: {titulo: "Confirme sua senha de acesso de 8 a 20 caracteres:"},
        invalidPassword: {titulo: "A senha deve conter pelo menos 8 caracteres."},
        matchError: {titulo: "Senha n\u00E3o confere com a informada."},
        footerText1: {titulo: "Dificuldades em alterar a senha?"},
        footerText2: {titulo: "Favor entrar em contato com nossa Central de Atendimento"},
        footerText3: {titulo: "Para sua segurança, evite usar combinações previsíveis como sua data de nascimento, número de identidade, CPF ou telefone."},
        welcomeText: {titulo: "Responda a duas perguntas de seguran\u00E7a"},
        errorNoAnswer: {titulo: "\u00C9 obrigat\u00F3rio responder a pergunta!"},
        changeBtn: {titulo: "Cadastrar/Alterar"},
        changeBtnDesc: {titulo: "Altera sua senha nos canais COOPERFORTE"},
        passwordChangedText: {titulo: "Atenção! Esta senha é de uso pessoal e exclusivo para acessar os canais digitais da COOPERFORTE."},
        passwordChangedText2: {titulo: "Memorize e guarde sua senha em local seguro e nunca compartilhe com terceiros."},
        passwordLength: {titulo: "Sua senha de acesso deve conter a seguinte combinação:"},
        haveOneNumber: {titulo: "N\u00FAmero"},
        haveUppercaseCaracter: {titulo: "Letra mai\u00FAscula"},
        haveLowercaseCaracter: {titulo: "Letra min\u00FAscula"},
        haveSpecialCaracter: {titulo: "Pelo menos 1 caractere especial (!@#$%&)"},
        passwordsMatch: {titulo: "Senha e Confirmação id\u00eanticas"},
        passwordHaveMinimumEightCaracters: {titulo: "8 a 20 caracteres"},
        titleModal400Error: {titulo: "As senhas informadas s\u00E3o inv\u00E1lidas, corrija e tente novamente."},
        titleModal409InvalidPassword: {titulo: "Atenção! A sua nova senha n\u00E3o pode ser igual a anterior."},
        passwordChangedBtnDesc: {titulo: 'Fecha a modal'},
        passwordChangedBtn: {titulo: 'Fechar'},
        passwordChangedTitle: {titulo: 'Sucesso'}
    },

    success: {
        welcomeText3: {titulo: "Senha de acesso cadastrada com sucesso!"},
        mainText: {titulo: "Atenção! Esta senha é de uso pessoal e exclusivo para acessar os canais digitais da COOPERFORTE."},
        mainText2: {titulo: "Memorize e guarde sua senha em local seguro e nunca compartilhe com terceiros."},
        navigateToBtn: {titulo: 'Acessar'},
        navigateToBtnDesc: {titulo: 'Acesse sua conta no Site Cooperforte'},
        footerText1: {titulo: "Ainda ficou alguma d\u00FAvida?"},
        footerText2: {titulo: "Favor entrar em contato com nossa Central de Atendimento"},
    }

}


// WEBPACK FOOTER //
// ./src/assets/data/initialLabels.data.js